import { appContext } from '../../../../AppContext';
import { IbssPage } from '../../../../Components/Core/BasePage/IbssPage';
import { JSX } from "react";
import { IRouterProps, withRouting } from "@iconics/components";
import { ApiConstants } from '../../../../Providers.Api/ApiConstants';
import { Solution } from './DataModels';
import Helper from '../../../../Common/Helper';
import { PagedResponse } from "@iconics/core";
import { Button, ButtonBar, Card, DataGrid, GridContainer, GridItem, IGridData, IGridRowsRequest, IGridRowsResponse, LayoutContainer, LayoutContent, RightButtons, TickSymbol } from "@iconics/components";
import { SerendieSymbol } from "@serendie/symbols";
import { YesNoEnum } from '@iconics/providers.fadx-platform-api-client-v2';
import { TypeHelper } from '@iconics/core';

class ListSolutions extends IbssPage<IProps, IState>
{
    private get labels() { return appContext().labels; }
    private get local() { return appContext().localStorageProvider; }
    private userCanCreate: boolean;

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            solutionsGrid: { rows: [] },
        };

        this.userCanCreate = this.local.hasRight('DATAMODEL.Solutions.Create');
    }

    public async componentDidMount(): Promise<void>
    {
        this.pageTitle = appContext().labels.Platform_Solution_PageTitle;
    }

    private async handleRowsRequest(request: IGridRowsRequest<ISolution>): Promise<IGridRowsResponse<ISolution>>
    {
        const response = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.solutions.get<PagedResponse<Solution[]>>({
            select: Solution,
            tenancy: appContext().tenantId,
            skipToken: request.skipToken,
            top: request.take,
            orderBy: DataGrid.toODataOrderBy(request.sorter),
        });

        const solutions = response.value.map(i => ({
            id: i.Id,
            name: i.Name,
            description: i.Description,
            isEnabled: TypeHelper.toBoolean(i.IsEnabled) ?? false,
            eTag: i.ConcurrencyStamp,
        }));

        return { rows: solutions, nextSkipToken: response.skipToken };
    }

    public render(): JSX.Element
    {
        return (
            <LayoutContainer>
                <LayoutContent>
                    <Card
                        title={this.labels.Platform_Solution_ListTitle}
                        subTitle={this.labels.Platform_Solution_ListSubTitle}
                        icon={<SerendieSymbol name='apps-square' />}
                    >
                        <GridContainer>
                            <GridItem>
                                <ButtonBar>
                                    <RightButtons>
                                        <Button
                                            size='small'
                                            styleType='ghost'
                                            leftIcon={<SerendieSymbol name='plus' />}
                                            onClick={() => this.props.navigate(`/admin/solutions/new`)}
                                            disabled={!this.userCanCreate}
                                        >
                                            {this.labels.Platform_CommonAction_Add}
                                        </Button>
                                    </RightButtons>
                                </ButtonBar>
                            </GridItem>
                            <GridItem>
                                <DataGrid
                                    columns={[
                                        {
                                            columnId: Helper.nameOf<Solution>("Name"),
                                            title: this.labels.Solution_Name,
                                            getCellValue: i => i.name,
                                            columnWidth: 25,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Solution>("Description"),
                                            title: this.labels.Solution_Description,
                                            getCellValue: i => i.description,
                                            columnWidth: 60,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Solution>("IsEnabled"),
                                            title: this.labels.Solution_IsEnabled,
                                            getCellValue: i => i.isEnabled,
                                            template: i => <TickSymbol value={i.value as boolean} />,
                                            columnWidth: 15,
                                            sortable: true,
                                        },
                                    ]}
                                    data={this.state.solutionsGrid}
                                    onChange={i => this.setState({ solutionsGrid: i })}
                                    rowId={i => i.id}
                                    onRowsRequest={i => this.handleRowsRequest(i)}
                                    onCellClicked={i => this.props.navigate(`/admin/solutions/${i.id}/edit`)}
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </LayoutContent>
            </LayoutContainer>
        )
    }
}

export default withRouting(ListSolutions);

export interface IProps extends IRouterProps
{
}

export interface IState
{
    solutionsGrid: IGridData<ISolution>;
}

export interface ISolution
{
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    eTag: string;
}